import React from 'react'
import PropTypes from 'prop-types'
import { Link, graphql, Img } from 'gatsby'
import ReactCursorPosition from 'react-cursor-position'
import { Tween } from 'react-gsap'
import { Power2 } from 'gsap/TweenMax'
import background from '../img/background.jpg'
import zicara from '../img/zicara.png'
import srce from '../img/srce.svg'
import mojeSarajevo from '../img/moje_sarajevo.png'
import mojaPrica from '../img/moja_prica.png'
import circles from '../img/circles.png'
import oranje from '../img/oranje.png'
import sffLogo from '../img/sff_logo.svg'
import tram from '../img/tram.png'
import sff_zgrade from '../img/zgrade.png'

class AnimatedHeader extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {

const Animation = (props) => {
     const {
       detectedEnvironment: {
         isMouseDetected = false,
         isTouchDetected = false
       } = {},
       elementDimensions: {
         width = 0,
         height = 0
       } = {},
       isActive = false,
       isPositionOutside = false,
       position: {
         x = 0,
         y = 0
       } = {}
     } = props;

     return (




        <div className="banner-sff">        
        <img src={sff_zgrade} className="sff-zgrade" />
          <Tween duration={1.2} from={ ['entering'] ? false : { yPercent: 250, ease: 'Power2.easeOut' } } to={ ['exiting'] ? { yPercent: -200, ease: 'Power2.easeIn' } : false } >
            <Tween to={{ x: -0.08 * x, y: 0.04 * y, transformPerspective: 900, transformOrigin: 'center'}}>
               <img key='x01' src={sffLogo} style={{ width: '5vw', height: 'auto', position: 'absolute', top: '5vw', bottom: 'auto', left:'25%', right:'auto', zIndex: '6'}}/>
           </Tween>
          </Tween>      
         <Tween to={{ x: 0.06 * x, y: 0.02 * y, transformPerspective: 900, transformOrigin: 'center'}}>
             <img key='x02' src={srce} style={{ width: '30vw', height: 'auto', position: 'absolute', top: 0, bottom: 0, left:'auto', right:'5%', zIndex: '5'}}/>
         </Tween>
         <Tween to={{ x: -0.03 * x, y: 0.02 * y,transformPerspective: 900, transformOrigin: 'center'}}>
             <img key='x03' src={mojeSarajevo} style={{ width: '30vw', height: 'auto', position: 'absolute', top: '10vw', bottom: 'auto', left:'18%', right:'auto', zIndex: '4'}}/>
         </Tween>
         <Tween to={{ x: 0.03 * x, y: 0.02 * y, transformPerspective: 900, transformOrigin: 'center'}}>
             <img key='x04' src={mojaPrica} style={{ width: '25vw', height: 'auto', position: 'absolute', top: '18.5vw', bottom: 'auto', left:'18%', right:'auto', zIndex: '3'}}/>
         </Tween>
         <Tween to={{ x: -0.02 * x, y: -0.02 * y, transformPerspective: 900, transformOrigin: 'center'}}>
             <img key='x05' src={circles} style={{ width: '65vw', height: 'auto', position: 'absolute', top: '10vw', bottom: 'auto', left: 0, right: 0, zIndex: '2'}}/>
         </Tween>
         <Tween to={{ x: -0.02 * x, transformPerspective: 900, transformOrigin: 'center'}}>
             <img key='x06' src={oranje} style={{ width: '35vw', height: 'auto', position: 'absolute', top: '19.5vw', bottom: 'auto', left: 'auto', right: '-2%', zIndex: '1'}}/>
         </Tween>
         <Tween duration={5} from={{ x: 0, y: 0 }} to={{yoyo: true, repeat: -1, xPercent: '-400', yPercent: '-270', ease: Power2.easeInOut}}>
             <img key='x07' src={zicara} style={{ width: '4vw', height: 'auto', position: 'absolute', top: '9.5vw', bottom: 'auto', left: 'auto', right: '27.3%', zIndex: '1'}}/>
         </Tween>
       </div>






     );
   };

    return (
      <ReactCursorPosition>    
        <Animation />
      </ReactCursorPosition> 
    );
  }
}


export default AnimatedHeader;